import controller from './alerts.controller'

export default {
  controller,
  template: require('./alerts.component.html').default
}
